<template>
  <modal :closeModal="closeModal">
    <div class="web-notifications-modal">
      <header>
        <h1 class="web-notifications-modal__title" v-if="user.isVolunteer">
          {{ $t('webNotificationsModal.volunteerTittle') }}
        </h1>
        <h1 v-else class="web-notifications-modal__title">
          {{ $t('webNotificationsModal.otherTittle') }}
        </h1>
      </header>

      <h2 class="web-notifications-modal__subtitle">
        {{ description }}
      </h2>

      <separator />

      <footer class="web-notifications-modal__footer">
        <div class="web-notifications-modal__buttons">
          <large-button @click.native="closeModal">{{
            $t('webNotificationsModal.closeModalButton')
          }}</large-button>
          <large-button primary @click.native="requestNotificationPermission">{{
            $t('webNotificationsModal.requestNotificationPermissionButton')
          }}</large-button>
        </div>
      </footer>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/Modal.vue'
import Separator from '@/components/Separator.vue'
import LargeButton from '@/components/LargeButton.vue'
import setNotificationPermission from '@/utils/set-notification-permission'

export default {
  name: 'WebNotificationsModal',
  components: { LargeButton, Modal, Separator },
  props: {
    closeModal: { type: Function, required: true },
    handleNotificationButton: { type: Function },
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
    description() {
      if (this.isVolunteerDashboardView)
        return this.$root.$t(
          'webNotificationsModal.descriptionIsVolunteerDashboardView'
        )
      if (this.user.isVolunteer)
        return this.$root.$t('webNotificationsModal.descriptionUserIsVolunteer')
      return this.$root.$t('webNotificationsModal.otherDescription')
    },
    isVolunteerDashboardView() {
      return this.$route.name === 'DashboardView' && this.user.isVolunteer
    },
  },
  methods: {
    async requestNotificationPermission() {
      document.querySelector('.upc-modal-form').remove()
      this.isSelectionNotificationPermission = true

      if (!('Notification' in window)) return
      if (Notification.permission == 'default') {
        const result = await Notification.requestPermission()
        setNotificationPermission(result)
        this.isSelectionNotificationPermission = false
      }
      if (this.handleNotificationButton) this.handleNotificationButton()
      this.closeModal()
    },
  },
}
</script>

<style lang="scss" scoped>
.web-notifications-modal {
  @include flex-container(column);

  &__title {
    @include font-category('display-small');
  }

  &__subtitle {
    @include font-category('body');
    margin: 0 0 35px;
    color: $c-secondary-grey;
    font-size: 15px;
  }

  &__buttons {
    margin-top: 16px;
    @include flex-container(row, flex-end);
    @include child-spacing(left, 16px);
  }
}

html.is-rtl .web-notifications-modal {
  direction: rtl;
  &__buttons {
    @include child-spacing-rtl(left, 16px);
  }
}
</style>
